import router from './'
import { WXlogin } from '@/utils/WXlogin'

const whiteListNames = ['Login', 'Register', 'BackPage', 'QRcode', 'Test', 'OpenIdPage', 'UserAgreement', 'ServiceAgreement']

// 修复每一个页面不一样的背景色
router.beforeEach((to, form, next) => {
  console.log(`to_path == ${to.path} ... localStorage['GATEWAY-SESSION'] = ${localStorage['GATEWAY-SESSION']}`)
  document.body.style.background = to.meta && to.meta.background || '#ffffff'
  if (localStorage['GATEWAY-SESSION']) {
    // 可能会涉及到登录授权 后期加入
    if (whiteListNames.includes(to.name)) {
      next()
    } else {
      const maps = Object.keys(to.query).map((key) => `${key}=${to.query[key]}`).join('&')
      console.log('存入缓存' + `${to.path}?${maps}`)

      if (localStorage.getItem('redirect') === null || localStorage.getItem('redirect') === 'null') {
        localStorage.setItem('redirect', `${to.path}?${maps}`)
      }
      console.log(localStorage.getItem('redirect') + '111111111' + JSON.stringify(localStorage.getItem('redirect')))
      next()
    }
  } else {
    if (whiteListNames.includes(to.name)) {
      // setLocalStore('deviceCode', .deviceCode)
      console.log(window.document.location.href.query)
      console.log('没走缓存')
      next()
      return
    }
    // wangsh 7-2
    // sessionStorage.setItem('redirect', to.path)
    const maps = Object.keys(to.query).map((key) => `${key}=${to.query[key]}`).join('&')
    console.log('存入缓存' + `${to.path}?${maps}`)
    if (localStorage.getItem('redirect') === null || localStorage.getItem('redirect') === 'null') {
      localStorage.setItem('redirect', `${to.path}?${maps}`)
    }
    console.log(localStorage.getItem('redirect') + '111111111' + JSON.stringify(localStorage.getItem('redirect')))
    WXlogin(to.path)
    // next('/backPage')
  }
})
